import React from 'react';
import SEO from '../components/SEO';
import HeroNew from '../components/HeroNew';
import FeaturedProjects from '../components/FeaturedProjects';
import Achievements from '../components/Achievements';
import WhoWeAre from '../components/WhoWeAre';
import Values from '../components/Values';
import Contact from '../components/Contact';
import Clients from '../components/Clients';

function Home() {
    return (
        <>
            <SEO
                title="Rainbow Craft Signs & Graphics - Signage & Branding Solutions | Abu Dhabi, UAE"
                description="Rainbow Craft Signs & Graphics LLC - Leading signage and branding company in Dubai, UAE. Expert LED signage, neon signs, 3D lettering, vehicle wrapping, corporate branding, exhibition booths, and wayfinding systems. Serving Dubai, Abu Dhabi, and UAE. Call +971 50 860 4485"
                keywords="rainbow craft, signage company dubai, LED signage dubai, neon signs dubai, 3D lettering dubai, vehicle wrapping dubai, corporate branding dubai, exhibition booth dubai, signage company UAE, branding solutions dubai, storefront signage dubai, wayfinding systems dubai, signage fabrication dubai, outdoor signage dubai, indoor signage dubai, digital signage dubai"
                url="/"
            />
            <HeroNew />
            <Clients />
            <FeaturedProjects />
            <Achievements />
            <WhoWeAre />
            <Values />
            <Contact />
        </>
    );
}

export default Home;
